export const text = {
    alignCenter: 'textAlignCenter',
    alignRight: 'textAlignRight',
};
